import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { treatExperiment } from 'src/app/shared/api/experiments';
import { isMobile } from 'src/app/shared/utils/userAgent';

import type { PsfShareDataQuery } from '../api.graphql';

type Experiment = PsfShareDataQuery['experiments']['desktopShareAssetsExperiment'];

type Params = {
	experiment: Experiment;
	utilityContext: UtilityContext;
	hasShareVisual: boolean;
};

export async function normalizeDesktopShareAssetsExperiment({
	experiment,
	utilityContext,
	hasShareVisual,
}: Params): Promise<Experiment['variation']> {
	if (shouldRunExperiment({ experiment, utilityContext, hasShareVisual })) {
		await treatExperiment(utilityContext, experiment.experimentName);
		return experiment.variation;
	}
	return 'control';
}

function shouldRunExperiment({ experiment, utilityContext, hasShareVisual }: Params): boolean {
	return isEnabledByFC(experiment) && !isMobile(utilityContext) && hasShareVisual;
}

/**
 * Returns false when FCM is not configured or the experiment name is invalid,
 * per the configuration in packages/experiments/src/configs/configs/desktop_share_assets_experiment.ts
 */
function isEnabledByFC(experiment: Experiment): boolean {
	return experiment.experimentName !== '__invalid_experiment__';
}
